import {Button, FormControl, Grid, InputLabel, Select, TextField} from "@mui/material";
import React, {useState} from "react";
import {IFlag} from "@models/shared/IFlag.ts";
import dayjs from "dayjs";
import {IntInputEntry} from "@shared/specialComponents/InputEntry.tsx";
import {fullHeight} from "@models/helpers.ts";
import {FlagTypes} from "@models/shared/FlagTypes.ts";
import {useFlags} from "@components/flags/hooks/useFlags.ts";
import {useAlert} from "@contexts/hooks/useAlert.ts";
import {Publish} from "@mui/icons-material";

interface CreateFlagComponentProps {
    preset?: { tipo?: FlagTypes }
    onCreate?: (v: IFlag) => void
}

export function CreateFlagComponent(props: CreateFlagComponentProps) {
    const {createFlag} = useFlags()
    const {createAlertFromResponse} = useAlert()

    const [value, setValue] = useState<IFlag>(
        {
            isAtivo: true, nome: '', id: 0, dataCriacao: dayjs(),
            ordem: 0, usuarioCriacaoId: 0, tipo: props.preset?.tipo ?? "FlagOrcamento"
        }
    )

    return (
        <Grid container size={12}>
            <Grid size={{sm: 12, md: 6}}>
                <TextField value={value.nome} onChange={(e) => setValue({...value, nome: e.target.value})}
                           label={'nome'}/>
            </Grid>
            <Grid size={{sm: 12, md: 6}}>
                <TextField value={value.descricao} onChange={(e) => setValue({...value, descricao: e.target.value})}
                           label={'descricao'}/>
            </Grid>
            <Grid size={{sm: 12, md: 6}}>
                <IntInputEntry clampValues={{min: 0, max: 1000}} value={value.ordem}
                               onChange={v => setValue({...value, ordem: v})} label={'ordem'}/>
            </Grid>
            <Grid size={{sm: 12, md: 6}}>
                <FormControl sx={{...fullHeight}} variant={'filled'} fullWidth>
                    <InputLabel>Tipo de sinalização</InputLabel>
                    <Select sx={{...fullHeight}} value={value.tipo}>
                        {FlagTypes.map(x => {
                            return <option key={x} value={x}>{x}</option>
                        })}
                    </Select>
                </FormControl>
            </Grid>
            <Grid mt={1} container size={12} justifyContent={'space-between'} alignItems={'center'}>
                <Grid/>
                <Grid>
                    <Button color={'success'}
                            disabled={value.nome.length < 3}
                            endIcon={<Publish/>}
                            size={'large'}
                            fullWidth
                            sx={{...fullHeight}}
                            onClick={() => {
                                createFlag(value).then(x => {
                                    createAlertFromResponse(x)
                                    if (x.status == 'Success') {
                                        if (props.onCreate != null)
                                            props.onCreate(x.items)
                                    }
                                })
                            }}>Criar</Button>
                </Grid>
            </Grid>

        </Grid>
    )
}
